export default class BuyLinesRowData {
    constructor(value) {
        this.chargeType = value.chargeType[0] || "";
        this.brand = value.brand[0] || "";
        this.chargePeriod = value.chargePeriod[0] || "";
        this.vendorNo = value.vendorNo[0] || "";
        this.assVendorNo = value.assVendorNo[0] || "";
        this.custNo = value.custNo[0] || "";
        this.raNumber = value.ranumber[0] || "";
        this.licRentAgreeNo = value.licRentAgreeNo[0] || "";
        this.cc1 = value.cc1[0] || "";
        this.netVouchValue = value.netVouchValue[0] || "";
        this.diValue = value.divalue[0] || "";
        this.totalBuyRent = value.totalBuyRent[0] || "";
        this.cc2 = value.cc2[0] || "";
        this.voucherFee = value.voucherFee[0] || "";
        this.diFee = value.difee[0] || "";
        this.totalFee = value.totalFee[0] || "";
        this.cc3 = value.cc3[0] || "";
        this.cc4 = value.cc4[0] || "";
        this.crClValuePurch = value.crClValuePurch[0] || "";
        this.tmSplit = value.tmsplit[0] || "";
        this.cwdSplit = value.cwdsplit[0] || "";
        this.tpSplit = value.tpsplit[0] || "";
        this.paiSplit = value.paisplit[0] || "";
        this.oneWayFee = value.oneWayFee[0] || "";
        this.fuel = value.fuel[0] || "";
        this.cashRefund = value.cashRefund[0] || "";
        this.otherDed = value.otherDed[0] || "";
        this.totalDed = value.totalDed[0] || "";
        this.cc5 = value.cc5[0] || "";
        this.adjValue = value.adjValue[0] || "";
        this.adjReason = value.adjReason[0] || "";
        this.navReason = value.navreason[0] || "";
        this.custBillCurr = value.custBillCurr[0] || "";
        this.checkoutDate = value.checkoutDate[0] || "";
        this.locCode = value.locCode[0] || "";
        this.coLoc = value.coloc[0] || "";
        this.ciLoc = value.ciloc[0] || "";
        this.custAccNo = value.custAccNo[0] || "";
        this.custAccName = value.custAccName[0] || "";
        this.iata = value.iata[0] || "";
        this.agencyName = value.agencyName[0] || "";
        this.voucherNo = value.voucherNo[0] || "";
        this.voucherValue = value.voucherValue[0] || "";
        this.voucherComm = value.vouchComm[0] || "";
        this.commonTax = value.commonTax[0] || "";
        this.subTotal = value.subTotal[0] || "";
        this.fee = value.fee[0] || "";
        this.netBuySell = value.netBuySell[0] || "";
        this.countryCode = value.countryCode[0] || "";
        this.commRev = value.commRev[0] || "";
        this.commPerc = value.commPerc[0] || "";
        this.refComm = value.refComm[0] || "";
        this.refCommTax = value.refCommTax[0] || "";
        this.totRefCommTax = value.totRefCommTax[0] || "";
        this.diValueSoldPurch = value.divalueSoldPurch[0] || "";
        this.diBuySellFee = value.dibuySellFee[0] || "";
        this.secCreditID = value.secCreditID[0] || "";
        this.secCurrCode = value.secCurrCode[0] || "";
        this.fxRate = value.fxrate[0] || "";
        this.clInd = value.clind[0] || "";
        this.stationInd = value.stationInd[0] || "";
        this.vehicleRegNo = value.vehicleRegNo[0] || "";
    }
}